// extracted by mini-css-extract-plugin
export default {"wrapper":"sliding_wrapper__lRCio","slider":"sliding_slider__FW6PX","sliderContainer":"sliding_sliderContainer__oxQYi"};